<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-05-14 14:37:34
 * @LastEditTime : 2025-06-20 15:50:46
 * @LastEditors  : yangxr
 * @Description  : 业务记账单
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\docking\incomeSheet\incomeSheet.vue
-->
<template>
    <div class="pages_content table">
        <el-container>
            <el-header>
                <breaDcrumb />
            </el-header>
            <el-main style="display: flex">
                <div>
                    <el-collapse-transition>
                        <div v-show="showCardNav">
                            <div class="search">
                                <span style="display: inline-block; margin-bottom: 10px">
                                    <span style="margin-right: 12px">时间</span>
                                    <el-date-picker v-model="tableParam.businessTime" style="width: 150px;" type="month"
                                        unlink-panels value-format="yyyy-MM" start-placeholder="开始时间"
                                        end-placeholder="结束时间"></el-date-picker>
                                </span>
                                <span style="margin-left: 24px">
                                    <span style="margin-right: 12px">主体</span>
                                    <el-select ref="mianBodyId" v-model="tableParam.mainBodyId" style="width: 200px"
                                        filterable clearable>
                                        <el-option v-for="item in mainBodyList" :key="item.id" :label="item.name"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </span>
                                <el-button icon="el-icon-search" size="medium" class="bottom_all"
                                    @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重
                                    置</el-button>
                                    <el-button size="medium" class="bottom_all" style="margin-left: 12px" @click="downLoad()">导出</el-button>
                            </div>
                        </div>
                    </el-collapse-transition>
                    <div class="hr"></div>
                    <div class="card">
                        <div v-loading="tableLoading" class="card_info" :style="style">
                            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                                border stripe style="width: 100%" :data="tableData" tooltip-effect="dark"  @selection-change="handleSelectionChange">
                                <el-table-column type="selection"></el-table-column>
                                <template v-for="(item, index2) in table">
                                    <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                                        :width="item.width">
                                       
                                        <template slot-scope="scope">
                                            <span v-if="item.label == '共享推送'">
                                                <el-button size="mini" class="bottom_one"
                                                    @click="lookDetail(scope.row)">查看详情</el-button>
                                            </span>
                                            <span v-else-if="item.label == '状态'">
                                                <span v-if="scope.row.shareStatus == 1">成功</span>
                                                <span v-if="scope.row.shareStatus == 2">失败</span>
                                                <span v-if="scope.row.shareStatus == 3">部分成功</span>
                                            </span>
                                            <span v-else>{{ scope.row[item.prop] }}</span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                </div>
            </el-main>
            <div class="card_bottom">
                <div class="card_bottom_left">
                    <div class="top_page_totle">总共{{ total }}条</div>
                    <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
                        :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
                        :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
                </div>
                <div>
                    <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
                        @click="gettableData">刷新</el-button>
                </div>
            </div>
        </el-container>
    </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { incomeCheckQueryPage as queryPage, querymainBodyList,incomeExportList } from "@/api/docking.js";
export default {
    components: {
    },
    mixins: [mixin],
    data() {
        return {
            table: [
                { label: "主体公司", prop: "mainBodyName", status: true, width: "220" },
                { label: "账期时间", prop: "businessTime", status: true, width: "220" },
                { label: "提交人", prop: "createUserName", status: true, width: "auto" },
                { label: "共享推送", prop: "productionSite", status: true, width: "auto" },
                { label: "状态", prop: "shareStatus", status: true, width: "auto" },
            ],
            queryPage: queryPage,
            tableData: [],
            pagesType: 0,
            tableParam: {
                page: 1,
                pageSize: 10,
                mainBodyId: "",//筛选条件：主体
                businessTime: ""//筛选条件：时间
            },
            mainBodyList: [],
            selectedRows:[],
            ids:[],
        };
    },
    watch: {
    },
    async created() {
        querymainBodyList().then(res => {
            if (res.code == 1001) {
                this.mainBodyList = res.data
            }
        })
        const query = this.$route.query
    if(query.mainBodyId && query.businessTime){
      this.tableParam.mainBodyId = query.mainBodyId 
      this.tableParam.businessTime = query.businessTime
    }
        this.gettableData();
    },
    methods: {
        handleSelectionChange(val) {
    this.selectedRows = val;
    this.ids = val.map(item => item.id);  // 提取id数组
    console.log('选中id数组:', this.ids);
  },
        downLoad(){
            if(this.ids.length == 0) {
                this.$message({
                    message: '请选择数据',
                    type: 'warning'
                });
                return
            }
            this.$Download2(incomeExportList, this.ids);
        },
        lookDetail(row){
            this.$router.push({name:'incomeSheetDetail',query:{id:row.id}})
        },
        sizeChange(value) {
            this.tableParam.pageSize = value;
            this.gettableData();
        },
        /*重置数据,此方法必须存在，并且方发只重置条件*/
        init() {
            this.tableParam = this.$options.data().tableParam
            this.gettableData();
        },
    },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
    width: 240px;
}

.table_link {
    margin: 0 10px;
    color: $bg_color;
    cursor: pointer;
}

.table_link:hover {
    opacity: 0.8;
}</style>
  